
export default {
  name: 'ProductPopupModal',
  props: {
    cartElement: {
      type: Object,
      default: null,
    },
    bundleProducts: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      relatedProductsSwiperOptions: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  methods: {
    returnDefaultImage(images) {
      if (!images && !images.length) {
        return false
      }
      return images.filter((obj) => obj.default === true)
    },
  },
}
